import moment from 'moment'

import { OnSchedHelpers }  from '../OnSchedHelpers'
import { OnSchedResponse } from '../../OnSchedResponse'
import { OnSchedRest }     from '../../OnSchedRest'

export const OnChangeTimezone = (event, element) => {
  var el;

  // Check if target is option or child element
  if (event.target.dataset.offset) {
    el = event.target;
  }
  else if (event.target.parentElement.dataset.offset) {
    el = event.target.parentElement;
  }

  const timezoneName = el.dataset.tz;
  var elTimezone = document.getElementById('onsched-timezone');
  
  // Update times if element is availability
  if (element.type === 'availability') {
    elTimezone.classList.toggle('loading');
    var elSelectedDate = document.querySelector(".onsched-calendar .day.selected");
    var selectedDate = OnSchedHelpers.ParseDate(elSelectedDate.dataset.date);
    var url = OnSchedHelpers.CreateAvailabilityUrl(element.onsched.apiBaseUrl, element.params, selectedDate, timezoneName);
    var elAvailableTimes = document.getElementById('onsched-available-times-col');
    
    elAvailableTimes && elAvailableTimes.classList.contains('loading') ? null : elAvailableTimes.classList.add('loading');
  
    OnSchedRest.Get(url, function (response) {
      let detail = response;
      const elAvailability = document.getElementById(element.id);
      const selectedDate = document.querySelector('.onsched-calendar .day.selected')?.dataset.date;

      elAvailability.dispatchEvent(new CustomEvent("getAvailability", { detail }));
      OnSchedResponse.GetAvailability(element, response, selectedDate);
    })
  }

  var elTimezoneBtn = document.getElementById('onsched-timezone-button');
  var elTimezoneInput = document.getElementById('onsched-timezone-hidden-input');
  var elSelectedTimezoneData = {...el.dataset};
  
  Object.keys(elSelectedTimezoneData).map((tzDataName, idx) => elTimezoneBtn.dataset[tzDataName] = Object.values(elSelectedTimezoneData)[idx]);
  Object.keys(elSelectedTimezoneData).map((tzDataName, idx) => elTimezoneInput.dataset[tzDataName] = Object.values(elSelectedTimezoneData)[idx]);

  elTimezoneBtn.innerText = element.options.timezoneIanaFormat ? elSelectedTimezoneData.tz : elSelectedTimezoneData.tzname;
  elTimezoneInput.value = elSelectedTimezoneData.tz;

  if (elTimezone.classList.contains('loading'))
    elTimezone.classList.remove('loading');
}

export const OnChangeTimezoneSearch = e => {
  elTzList.innerHTML = '';

  [...elTzOptions].filter(opt => opt.innerText.toLowerCase().includes(e.target.value.toLowerCase()))
                  .forEach(opt => elTzList.appendChild(opt))
}
